import React, { useState } from "react";

const RefundAttireModal = ({
  onProceed,
  onClose,
  invitation,
  eventData,
  refundQuantities,
  setRefundQuantities,
}) => {
  const paidAttires = invitation?.eventAttire || [];

  const isSelected = (id) => refundQuantities[id] > 0;

  const formatCurrency = (amount) => {
    const num = typeof amount === "string" ? parseFloat(amount) : amount;

    if (num === 0) {
      return "Free";
    }

    const currency = eventData?.preferredCurrency || "NGN";
    const symbol = currency === "NGN" ? "₦" : "$";
    return `${symbol}${num.toLocaleString()}`;
  };

  const toggleSelect = (id) => {
    setRefundQuantities((prev) => {
      const copy = { ...prev };
      if (copy[id]) {
        delete copy[id];
      } else {
        copy[id] = 1;
      }
      return copy;
    });
  };

  const hasSelection = Object.keys(refundQuantities).length > 0;

  const capitalizeWords = (text = "") =>
    text
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");

  return (
    <div className="other-purchase-modal-overlay">
      <div className="other-purchase-modal-content attire-modal-large">
        <h2>Refund???</h2>
        <p className="purchase-modal-subtitle">
          To start the refund process, please select at least one item you'd
          like to request a refund for. Your request will be reviewed by the
          host, and if approved, a partial refund will be issued — please note
          that the full amount may not be returned.
        </p>

        <div className="refund-attire-grid">
          {paidAttires.map((attire) => {
            const selectedQty = refundQuantities[attire._id] || 0;
            const isSelected = selectedQty > 0;

            const maxQty = attire.quantity;
            const unitPrice = attire.price;

            return (
              <div
                key={attire._id}
                className={`refund-attire-card ${isSelected ? "selected" : ""}`}
                onClick={() => {
                  if (!isSelected) {
                    setRefundQuantities((prev) => ({
                      ...prev,
                      [attire._id]: 1,
                    }));
                  }
                }}
              >
                {isSelected && (
                  <span className="refund-attire-checkmark">✓</span>
                )}
                <div className="refund-attire-image-wrapper">
                  <img src={attire.uri} alt={attire.attireTag} />
                </div>
                <div className="refund-attire-price-info">
                  <span className="refund-attire-unit-price">
                    {formatCurrency(unitPrice)} ×{" "}
                    {isSelected ? selectedQty : maxQty}
                  </span>

                  <strong className="refund-attire-total-price">
                    {formatCurrency(
                      unitPrice * (isSelected ? selectedQty : maxQty),
                    )}
                  </strong>
                </div>
                <p className="refund-attire-attire-tag">
                  {capitalizeWords(attire.attireTag)}
                </p>

                {isSelected && (
                  <div
                    className="refund-attire-qty-controls"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <button
                      onClick={() =>
                        setRefundQuantities((prev) => {
                          const next = selectedQty - 1;
                          if (next === 0) {
                            const copy = { ...prev };
                            delete copy[attire._id];
                            return copy;
                          }

                          return { ...prev, [attire._id]: next };
                        })
                      }
                    >
                      –
                    </button>

                    <span>{selectedQty}</span>

                    <button
                      onClick={() =>
                        setRefundQuantities((prev) => ({
                          ...prev,
                          [attire._id]: Math.min(selectedQty + 1, maxQty),
                        }))
                      }
                      disabled={selectedQty === maxQty}
                    >
                      +
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="modal-controls">
          <button
            className="modal-button other-purchase-cancel"
            onClick={onClose}
          >
            Close
          </button>

          <button
            className="modal-button proceed-button"
            disabled={!hasSelection}
            onClick={() => onProceed(refundQuantities)}
          >
            Proceed
          </button>
        </div>
      </div>
    </div>
  );
};

export default RefundAttireModal;
